import React from "react";
import { FileUploader } from "react-drag-drop-files";
import Moment from "react-moment";
import { FORMAT_TIME, STATUS_EXCUTED } from "../../../../../api/constant";
import {
  useActionsTest,
  useDispatchTestForm,
  useTest,
} from "../../../../../context/inventory/TestFormProvider";
import FileUpload from "../../../../app/atoms/FileUpload";
import IconFile from "../../../../app/atoms/IconFile";
import "./document.css";
const Document = () => {
  const state = useTest();
  const dispatch = useDispatchTestForm();
  const actions = useActionsTest();
  const { test } = state;
  const { documents } = test.document;
  const { status_id } = test;

  const handleChange = (files) => {
    actions.addDocumentsToTest(files);
  };
  const fileTypes = ["JPEG", "PDF", "XLSX", "DOC"];
  return (
    <section className="container-fluid">
      <div className="flex">
        {status_id !== STATUS_EXCUTED && (
          <div className="upload-document-test-form container-fluid flex-column">
            <div className="flex ">
              <label className="font1">
                Suba archivos (imágenes, videos, pdf, excel y word)
              </label>
            </div>
            <div className="container-drop-file-test">
              <FileUpload handleChange={handleChange} fileTypes={fileTypes} />
            </div>
          </div>
        )}

        <div className="flex1 container-fluid">
          <table className="table no-bordered table-default-app">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Modificado por</th>
                <th className="d-none d-xl-block">Última modificación</th>
              </tr>
            </thead>
            <tbody>
              {documents.map((doc) => {
                return (
                  <tr key={doc.id}>
                    <td className="no-long-doument-name" title={doc.title}>
                      <IconFile type={doc.type} /> {doc.title}{" "}
                    </td>
                    <td>{doc.user_name}</td>
                    <td className="d-none d-xl-block">
                      <Moment format={FORMAT_TIME}>{doc.updated_at}</Moment>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Document;
